import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { CustomerLead, CustomerLeadAccount } from "@lib/types/CustomerLead";

export const apiGetCustomerLead = async <T extends ApiParams>(
  customerLeadId: string,
  params?: T,
) => {
  const url = ApiUrlPrepare({
    params,
    url: `/customer-user/${customerLeadId}`,
  });
  return API.get<CustomerLead>(url);
};

export const apiAddCustomerLead = async (data: CustomerLead) => {
  return API.post<CustomerLead>(`/customer-user`, data);
};

export const apiDeleteCustomerLead = async (data: CustomerLead) => {
  return API.delete<null>(`/customer-user/${data.id}`);
};

export const apiUpdateCustomerLead = async (data: CustomerLead) => {
  const { id, ...rest } = data;
  return API.patch<CustomerLead>(`/customer-user/${id}`, rest);
};

export const apiGetCustomerLeads = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/customer-user` });
  return API.get<PaginationType<CustomerLead>>(url);
};

export const apiGetCustomerLeadAccounts = async (customerLeadId: string) => {
  const url = `/customer-user/account/${customerLeadId}`;
  return API.get<CustomerLeadAccount[]>(url);
};
